import React from "react";
import "../stylesheets/Landing.css";
import { motion, AnimatePresence } from "framer-motion";

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
      image: "../landingImages/PromoMaterial_Page_2.jpg",
    };
  }

  images = [
    "../landingImages/PromoMaterial_Page_2.jpg",
    "../landingImages/PromoMaterial_Page_3.jpg",
    "../landingImages/PromoMaterial_Page_4.jpg",
    "../landingImages/PromoMaterial_Page_5.jpg",
    "../landingImages/PromoMaterial_Page_6.jpg",
  ];

  //intervalId = null;

  intervalId = window.setInterval(() => {
    this.setState({
      image: `../landingImages/PromoMaterial_Page_${this.state.count + 2}.jpg`,
      count: this.state.count < 4 ? this.state.count + 1 : 0,
    });
  }, 4000);

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    return (
      <div className="landing-container" id="#">
        <div className="landing">
          <div className="landing-content">
            <motion.div
              initial={{ overflow: "hidden" }}
              animate={{
                overflow: "visible",
                transition: { delay: 2 },
              }}
              className="animation-wrapper"
            >
              <motion.h1
                initial={{ y: 100, opacity: 0 }}
                animate={{
                  y: 0,
                  opacity: 1,
                  transition: { duration: 1.5, type: "spring", delay: 0.75 },
                }}
                className="landing-title"
              >
                PROJECT STEELWALKER
              </motion.h1>
            </motion.div>
            {/* <img src="./landing.gif" alt="" className="landing-image" /> */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { duration: 1, delay: 2 } }}
              className="landing-desc-container"
            >
              <p className="landing-desc">
                Take your favourite co-op partner on an adventure into a vibrant
                and mysterious world. Each equipped with your own unique set of
                tools, work together to traverse massive mechs, fight rogue
                robots, and solve challenging puzzles on your journey to save
                your home village from destruction.
              </p>
              {/* <div className="landing-genre">
                <ul className="landing-genre-list">
                  <li>Third-Person</li>
                  <li>Co-op</li>
                  <li>Adventure</li>
                  <li>Puzzle</li>
                </ul>
              </div> */}
              <div className="landing-video-container">
                <video
                  className="landing-video"
                  src="../Steelwalker_SizzleReel.mp4"
                  controls
                  autoPlay
                  muted
                  loop
                ></video>
              </div>
              <div className="landing-images">
                <AnimatePresence exitBeforeEnter>
                  <motion.img
                    key={this.state.image}
                    src={this.state.image}
                    initial={{
                      opacity: 0,
                      width: "100%",
                    }}
                    animate={{
                      // x: 0,
                      opacity: 1,
                      transition: { duration: 0.5, type: "tween" },
                    }}
                    exit={{
                      opacity: 0,
                      transition: { duration: 0.5, type: "tween" },
                    }}
                  />
                </AnimatePresence>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    );
  }
}

export default Landing;
